import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import CustomButton from './Button';
import Input from './Input';
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import SaveIcon from '@mui/icons-material/Save';
import { authPostRequest } from 'Api/api';
import { validateFields } from 'pages/roofSection/validateFields';
import PropTypes from 'prop-types';

const RoofSectionHeader = ({
  roofId,
  projectId,
  price,
  roofName,
  roofDescription,
  setErrorMessage,
  setSuccessMessage,
  setShowAlertBar,
  setShowLoader,
  quotationTypeId
}) => {
  const [roofSectionName, setRoofSectionName] = useState(roofName);
  const [roofSectionDescription, setRoofSectionDescription] = useState(roofDescription);
  const [roofSectionNameLocal, setRoofSectionNameLocal] = useState(roofName);
  const [roofSectionDescriptionLocal, setRoofSectionDescriptionLocal] = useState(roofDescription);
  const [isEdit, setIsEdit] = useState(false);
  const [errors, setErrors] = useState({});
  const { userData, readOnly } = useSelector((store) => store.auth);

  const handleError = (input, errorMessage) => {
    setErrors((prevState) => ({ ...prevState, [input]: errorMessage }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowAlertBar(false);
    setErrorMessage([]);
    setSuccessMessage([]);

    try {
      const requestParams = {
        userId: userData.userId,
        projectId: projectId,
        name: roofSectionName.trim(),
        roofSectionId: roofId,
        price: price,
        description: roofSectionDescription.trim(),
        quotationTypeId: quotationTypeId // to be changed to dynamic one
      };

      setShowLoader(true);
      const validRoofSection = validateFields(
        'name',
        roofSectionName,
        'description',
        roofSectionDescription,
        handleError
      );
      const createRoofSection =
        validRoofSection && (await authPostRequest('saveRoofSection', requestParams));
      setShowLoader(false);

      if (createRoofSection) {
        if (createRoofSection.resStatus === 1) {
          setRoofSectionNameLocal(roofSectionName);
          setRoofSectionDescriptionLocal(roofSectionDescription);
          setSuccessMessage([createRoofSection.resMessage]);
          setIsEdit(!isEdit);
        } else {
          setErrorMessage([createRoofSection.resMessage]);
        }
        setShowAlertBar(true);
      }
    } catch (err) {
      setShowLoader(false);
      console.log(err);
    }
  };

  return (
    <Grid item xs={12}>
      <Grid display="flex" alignItems="center" justifyContent="space-between" sx={{ mt: 2, mb: 0 }}>
        <Grid xs={11}>
          <Input
            sx={{ mx: 0, mb: 3 }}
            type="text"
            placeholder="Enter roof section name"
            onChange={(e) => setRoofSectionName(e.target.value)}
            value={roofSectionName}
            readOnly={!isEdit}
            required={true}
            disabled={!isEdit}
            label="Roof Section"
            onFocus={() => handleError('name', null)}
            name="name"
            maxLength={149}
            error={errors.name}
          />
          {isEdit && (
            <Input
              sx={{ mx: 0, mb: 2 }}
              type="text"
              placeholder="Enter roof section description"
              onChange={(e) => setRoofSectionDescription(e.target.value)}
              value={roofSectionDescription}
              required={true}
              readOnly={!isEdit}
              multiline={true}
              rows={2}
              label="Description"
              onFocus={() => handleError('description', null)}
              name="description"
              maxLength={499}
              error={errors.description}
            />
          )}
        </Grid>
        {isEdit ? (
          <Grid
            sx={{
              mt: errors.name ? 15 : 12.4,
              mb: errors.description ? 2.5 : 0,
              direction: 'column-reverse'
            }}>
            <Grid display="flex">
              <CustomButton
                sx={{ mb: 1 }}
                type="button"
                endIcon={<ClearIcon />}
                onClick={() => {
                  handleError('name', null);
                  handleError('description', null);
                  setRoofSectionName(roofSectionNameLocal);
                  setRoofSectionDescription(roofSectionDescriptionLocal);
                  return setIsEdit(false);
                }}>
                Cancel
              </CustomButton>
              <CustomButton
                sx={{ mb: 1 }}
                type="submit"
                endIcon={<SaveIcon />}
                onClick={submitHandler}>
                Save
              </CustomButton>
            </Grid>
          </Grid>
        ) : (
          !readOnly && (
            <CustomButton
              type="submit"
              sx={{ marginBottom: 3 }}
              endIcon={<EditIcon sx={{ marginBottom: '0.7vh' }} />}
              onClick={() => setIsEdit(true)}>
              Edit
            </CustomButton>
          )
        )}
      </Grid>
    </Grid>
  );
};

RoofSectionHeader.propTypes = {
  openModal: PropTypes.bool,
  isFormSaved: PropTypes.bool,
  projectId: PropTypes.number,
  quotationTypeId: PropTypes.number,
  roofId: PropTypes.number,
  setIsFormSaved: PropTypes.func,
  setOpenModal: PropTypes.func,
  setSuccessMessage: PropTypes.func,
  setErrorMessage: PropTypes.func,
  setShowAlertBar: PropTypes.func,
  roofName: PropTypes.string,
  roofDescription: PropTypes.string,
  price: PropTypes.string,
  setShowLoader: PropTypes.func
};

export default RoofSectionHeader;
